module.exports = __webpack_public_path__ + "static/media/Screenshot5.5c4ce183.png";